import * as types from '../../actions/actiontypes';
import initialstate from '../initialstate';
import _ from 'lodash';
import {AccountType} from '../../util/uiconstants';

export function craAccountValidationCountReducer(state = initialstate.craAccountValidationCount, action) {
	switch (action.type) {
		case types.GET_CRA_ACCOUNTS_VALIDATION_COUNT: {
			const accounts = action.response?.data || [];
			let validationCount = 0;

			accounts?.forEach((account) => {
				const {accountTypeId, assertions, rationale} = account;

				const isSpecialType = [AccountType.InSignificant, AccountType.LimitedRisk].includes(accountTypeId);

				if (isSpecialType) {
					if (_.isEmpty(rationale)) validationCount++;
				} else if (_.isEmpty(assertions)) {
					validationCount++;
				} else {
					validationCount += assertions.filter((assertion) => _.isEmpty(assertion.craValue)).length;
				}
			});

			return validationCount;
		}

		default:
			return state;
	}
}
